import { createSelector } from 'reselect';
import { RefObject } from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export interface ListProps<T = any> {
  data: T[];
  renderItem: (item: T, index: number, ref?: RefObject<HTMLElement>) => React.ReactNode;
}

interface ListState {
  startIndex: number;
  endIndex: number;
}

export const selectItems = createSelector(
  (props: ListProps) => props.data,
  (_: ListProps, state: ListState) => state.startIndex,
  (_: ListProps, state: ListState) => state.endIndex,
  (props: ListProps) => props.renderItem,
  (_: ListProps, __: ListState, ref: RefObject<HTMLElement> | undefined) => ref,
  (data, startIndex, endIndex, renderItem, ref) => {
    return data
      .slice(startIndex, endIndex + 1)
      .map((item, index) =>
        renderItem(item, index + startIndex, index === 0 ? ref : undefined),
      );
  },
);
